import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient singleton.
 *
 * Exported as a module-level instance (rather than created inline in main.tsx)
 * so non-React code can reach it — specifically authStore.logout(), which
 * clears the cache so a second user logging in on the same tab never sees the
 * previous user's cached tenant data.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
